import { Field, Form, Formik } from "formik";

import { getApi, postApi, putApi } from "../../services/api/globalApi";
import { userValidation } from "../../utils/validations/userValidation";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import Select from "../../components/common/inputs/Select";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useState } from "react";
import SocialGrpoupLinkCodeSelect from "../../components/common/inputs/SocialGroupsLinkCodeSelect";

export default function User() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);
  const [qrcode, setQrcode] = useState("");
  const [linkCodes, setLinkCodes] = useState([]);
  const [defaultRole] = useState(() => utils?.ROLES_VALUES?.[0]?.value || "admin");

  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
      linkCodes,
      sabooraAllowed: values.sabooraAllowed === "true" ? true : false,
      raychatAllowed: values.raychatAllowed === "true" ? true : false,
    };
    try {
      if (!location?.state) {
        await postApi({
          path: "admin/users",
          body: JSON.stringify(body),
        });
        successMessage("کاربر با موفقیت اضافه شد");
        resetForm();
      } else {
        const response = await putApi({
          path: `admin/users/${location?.state.id}`,
          body: JSON.stringify(body),
        });
        successMessage("اطلاعات کاربر با موفقیت آپدیت شد.");
      }
      navigate("/user-list");
    } catch (error) {
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const updateRole = async (role) => {
    const path = `admin/users/${location?.state?.id}/role`;
    const body = {
      role: role,
    };
    try {
      await putApi({ path, body });
      successMessage("نقش کاربر با موفقیت آپدیت شد.");
      navigate("/user-list");
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const setGoogleSecret = async () => {
    const path = `admin/users/${location?.state?.id}/totpSecret`;
    try {
      const data = await putApi({ path });
      setQrcode(data.data?.result);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  return (
    <>
      <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
        <Title title={!location.state ? "افزودن کاربر" : "ویرایش کاربر"} />
        <Formik
          enableReinitialize
          initialValues={
            location.state
              ? {
                  mobile: location?.state.mobile || "",
                  name: location?.state.name || "",
                  address: location?.state.address || "",
                  role: location?.state.role || "",
                  sabooraAllowed: location?.state.sabooraAllowed ? "true" : "false",
                  raychatAllowed: location?.state.raychatAllowed ? "true" : "false",
                  qrcode: location?.state.qrcode || "",
                }
              : {
                  mobile: "",
                  password: "",
                  name: "",
                  address: "",
                  role: defaultRole,
                  sabooraAllowed: "true",
                  raychatAllowed: "false",
                }
          }
          validationSchema={userValidation(!!location.state)}
          onSubmit={formHandler}
        >
          {(formik) => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <Input
                    disabled={location.state ? "disabeld" : ""}
                    name={"mobile"}
                    placeholder={"موبایل"}
                    label="موبایل"
                    type="text"
                    required
                  />
                  <Input
                    name={"name"}
                    placeholder={"نام"}
                    label="نام"
                    type="text"
                  />
                  {!location.state && (
                    <Input
                      name={"password"}
                      placeholder={"رمز عبور"}
                      label="رمز عبور"
                      type={"password"}
                      required
                    />
                  )}
                  <SocialGrpoupLinkCodeSelect
                    label={"لینک های ارجاع"}
                    oldData={location?.state?.linkCodes || []}
                    onChange={setLinkCodes}
                  />
                  <div className="grid gap-6 md:grid-cols-2 md:col-span-2">
                    <Field
                      as="select"
                      name="sabooraAllowed"
                      label="اجازه خرید صبورا دارد ؟"
                      component={Select}
                    >
                      <option value={"true"}>بله</option>
                      <option value={"false"}>خیر</option>
                    </Field>
                    <Field
                      as="select"
                      name="raychatAllowed"
                      label="دسترسی به چت‌بات"
                      component={Select}
                    >
                      <option value={"true"}>بله</option>
                      <option value={"false"}>خیر</option>
                    </Field>
                  </div>

                  <Field
                    as="select"
                    name="role"
                    label="نقش"
                    component={Select}
                    required
                    disabled={!utils?.ROLES_VALUES?.length}
                  >
                    {utils?.ROLES_VALUES?.length ? (
                      utils.ROLES_VALUES.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.name}
                        </option>
                      ))
                    ) : (
                      <option value="">در حال بارگذاری...</option>
                    )}
                  </Field>
                  {formik.errors.role && formik.touched.role ? (
                    <p className="text-sm my-4 text-red-900 dark:text-red-400">
                      {formik.errors.role}
                    </p>
                  ) : null}
                  <Input
                    name={"address"}
                    placeholder={"آدرس"}
                    label={"آدرس"}
                    type={"textarea"}
                  />
                </div>
                <div className="flex flex-col gap-y-2">
                  <div className="flex items-center gap-2 mt-6">
                    <Button
                      text={location?.state ? "ویرایش" : "افزون"}
                      color={"success"}
                    />
                    {location?.state && (
                      <Button
                        onClick={() => updateRole(formik.values.role)}
                        type="button"
                        text={"آپدیت نقش"}
                        color={"success"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {location.state && location.state?.role === "admin" ? (
        <div className="mt-4 bg-white dark:bg-gray-900 rounded-3xl p-6">
          <Title title={"totp secret"} />
          <div className="mt-4 grid gap-6 mb-4 md:grid-cols-2">
            <div className="flex items-center gap-2 mt-6">
              <Button
                text={"ایجاد totp جدید"}
                onClick={setGoogleSecret}
                color={"success"}
              />
            </div>
            <br />
            {qrcode ? (
              <div>
                <img className="w-sm" src={qrcode} alt="QR Code" />
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
      {location.state ? (
        <div className="bg-white mt-4 dark:bg-gray-900 rounded-3xl p-6">
          <Title title={"لینک های ارجاع فروشنده"} />

          <div className="space-y-2 mt-4">
            {location.state.linkCodes?.map((i, index) => {
              const link = `https://attarbashii.co/?linkCode=${utils?.SOCIAL_MEDIA_LINK_CODE[i]?.value}`;
              return (
                <div
                  key={index}
                  className="flex items-center justify-between bg-gray-100 dark:bg-gray-800 rounded-xl p-3"
                >
                  <span className="text-sm break-all">{link}</span>
                  <button
                    className="text-blue-600 hover:text-blue-800 text-sm"
                    onClick={() => {
                      navigator.clipboard.writeText(link);
                    }}
                  >
                    کپی
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
}
